import React, { useRef, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Stack,
  Box
} from '@mui/material';
import { BrowserQRCodeReader } from '@zxing/browser';

const QRReader = () => {
  const [result, setResult] = useState('');
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(false);
  const videoRef = useRef(null);

  const stopVideoStream = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const handleStartScan = async () => {
    setResult('');
    setError('');
    setScanning(true);

    try {
      const codeReader = new BrowserQRCodeReader();

      const devices = await BrowserQRCodeReader.listVideoInputDevices();
      if (devices.length === 0) throw new Error('No video devices found');

      const backCamera = devices.find(d =>
        /back|rear|environment/i.test(d.label)
      ) || devices[0];

      const scanResult = await codeReader.decodeOnceFromVideoDevice(
        backCamera.deviceId,
        videoRef.current
      );

      setResult(scanResult.getText() || '(no value)');
    } catch (err) {
      console.error('Scan error:', err);
      setError(err.message || 'Failed to scan QR code');
    } finally {
      stopVideoStream();
      setScanning(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(result);
      alert('Copied to clipboard!');
    } catch (err) {
      console.error('Clipboard copy failed:', err);
      alert('Failed to copy.');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        QR Code Reader
      </Typography>

      <Stack spacing={2} alignItems="center">
        <Button
          variant="contained"
          onClick={handleStartScan}
          disabled={scanning}
        >
          {scanning ? 'Reading...' : 'Start reader'}
        </Button>

        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}

        {result && (
          <>
            <Typography variant="body1">
              <strong>Scanned:</strong> {result}
            </Typography>
            <Button variant="outlined" onClick={handleCopy}>
              Copy to Clipboard
            </Button>
          </>
        )}

        <Box sx={{ width: '100%', aspectRatio: '4/3' }}>
          <video
            ref={videoRef}
            style={{ width: '100%', objectFit: 'cover' }}
            muted
            playsInline
            autoPlay
          />
        </Box>
      </Stack>
    </Container>
  );
};

export default QRReader;
